import { useParams } from 'react-router-dom'
import { useAuthContext } from '@/context-state/AuthContext.jsx'

// Get the relevant account based on the URL ':accountId'
export const useCurrentAccount = () => {
    const { accountId } = useParams()
    const { accounts } = useAuthContext()

    const currentAccount = accounts.find(account => account._id === accountId)

    return { account: currentAccount }
}